import styled from "@emotion/styled";

export const Iframe = styled.iframe`
  aspect-ratio: 16 / 9;
  inline-size: 100%;
  block-size: auto;
  border: 0;
`;
